export default class RCCRCreateCompanyPayloadDTO {
    companyName = "";
    dba = "";
    companyEin = "";
    businessEntityType: string | null = null;
    companyStatus: string | null = null;
    officerSsn = "";
    officerFirstName = "";
    officerLastName = "";
}